import React, { useCallback, useContext } from 'react'
import SectionFormContainer from '../components/SectionFormContainer'
import DaycareWizardContext from './DaycareWizardContext'
import { Checkbox, makeStyles } from '@material-ui/core'
import { FONT_WEIGHTS } from '../../../utils'
import useDaycareVisit from '../../../hooks/useDaycareVisit'

const useStyles = makeStyles(() => ({
	root: { display: 'flex', flexDirection: 'column', flex: 1, width: '55%', gap: '2rem', alignItems: 'center' },
	subtextContainer: {
		textAlign: 'center',
		fontFamily: 'Nunito',
		fontSize: '0.875rem',
		fontWeight: FONT_WEIGHTS.SemiBold
	},
	formContainer: { display: 'flex', flex: 1, width: '80%', gap: '.75rem', marginTop: '0' },
	checkBoxContainer: {
		'& .MuiCheckbox-root': {
			padding: 0
		}
	},
	policyTextContainer: {
		fontFamily: 'Nunito',
		fontSize: '1rem',
		fontWeight: FONT_WEIGHTS.SemiBold
	}
}))

const CancelationPolicy = (props) => {
	const classes = useStyles()
	const {
		wizardContextProvider: { wizard_state, setWizardAttributeAndValues }
	} = useContext(DaycareWizardContext)
	const { attr, subtext = '', title = '' } = props
	const { getCancellationPolicy } = useDaycareVisit()

	const handleSelection = useCallback(
		(e) => {
			if (e.target && e.target.checked !== undefined) {
				const newValues = { ...wizard_state }
				newValues[attr] = e.target.checked
				setWizardAttributeAndValues(newValues)
			}
		},
		[wizard_state, setWizardAttributeAndValues, attr]
	)

	return (
		<SectionFormContainer title={title}>
			<div className={classes.root}>
				<div className={classes.subtextContainer}>{subtext}</div>
				<div className={classes.formContainer}>
					<div className={classes.checkBoxContainer}>
						<Checkbox onChange={handleSelection} checked={wizard_state[attr] === true} />
					</div>
					<div className={classes.policyTextContainer}>
						{getCancellationPolicy(wizard_state['pets'].length, true)}
					</div>
				</div>
			</div>
		</SectionFormContainer>
	)
}

export default CancelationPolicy
